import GA4Events from "//www.veimia.com/cdn/shop/t/83/assets/ga4.events.js?v=116580433145466843061734924205";

(function ($) {
  $(document).ready(function () {
    $('[ga4-controls]').on('click', function () {
      const eventName = _.toLower($(this).attr('ga4-controls'));
      if (typeof GA4Events[eventName] !== 'undefined') {
        const defaultAttrs = {
          content_type: $(this).attr('ga4-controls'),
          section_id: $(this).attr('ga4-section-id'),
          section_name: $(this).attr('ga4-section-name'),
        };
        GA4Events[eventName].apply(this, [this, defaultAttrs]);
      } else {
        const defaultAttrs = {
          content_type: $(this).attr('ga4-controls'),
          section_id: $(this).attr('ga4-section-id'),
          section_name: $(this).attr('ga4-section-name'),
          series_name: $(this).attr('ga4_series_name'),
        };

        GA4Events['custom_event'].apply(this, [this, defaultAttrs]);
        // console.log(`GA4 event named {${eventName}} is not defined`);
      }
    });
    $(document).on('click', '[ga4-async]', function () {
      const eventName = _.toLower($(this).attr('ga4-controls'));
      if (typeof GA4Events[eventName] !== 'undefined') {
        const defaultAttrs = {
          content_type: $(this).attr('ga4-controls'),
          section_id: $(this).attr('ga4-section-id'),
          section_name: $(this).attr('ga4-section-name'),
        };
        GA4Events[eventName].apply(this, [this, defaultAttrs]);
      } else {
        console.log(`GA4 event named {${eventName}} is not defined`);
      }
    });

    $('video[data-ga4-play]').on('play', function (event) {
      const eventName = _.toLower($(this).attr('ga4-controls'));
      if (typeof GA4Events[eventName] !== 'undefined') {
        const defaultAttrs = {
          content_type: $(this).attr('ga4-controls'),
          section_id: $(this).attr('ga4-section-id'),
          section_name: $(this).attr('ga4-section-name'),
        };
        console.log(GA4Events[eventName]);
        GA4Events[eventName].apply(this, [this, defaultAttrs]);
      } else {
        console.log(`GA4 event named {${eventName}} is not defined`);
      }
    });
    // 评论图片
    $(document).on('click', '.jdgm-gallery-wrapper .jdgm-gallery .jdgm-gallery__thumbnail-link', function () {
      // 获取当前画廊内的索引
      const $gallery = $(this).closest('.jdgm-gallery');
      const galleryIndex = $gallery.find('.jdgm-gallery__thumbnail-link').index(this);

      console.log('画廊内索引:', galleryIndex);
      const defaultAttrs = {
        content_type: 'product_comment',
        section_id: 'product_comment',
        section_name: 'product_comment',
        series_name: `product_comment_picture-${galleryIndex}`,
      };
      GA4Events['custom_event'].apply(this, [this, defaultAttrs]);
    });
    
    // 评论大图
     $(document).on('click', '.jm-mfp-carousel .jdgm-gallery .jdgm-gallery__thumbnail-link', function () {
      // 获取当前画廊内的索引
      const $gallery = $(this).closest('.jdgm-gallery');
      const galleryIndex = $gallery.find('.jdgm-gallery__thumbnail-link').index(this);

     
      const defaultAttrs = {
        content_type: 'product_comment',
        section_id: 'product_comment',
        section_name: 'product_comment',
        series_name: `product_comment_big_picture-${galleryIndex}`,
      };
        console.log('画廊内索引:', defaultAttrs);
      GA4Events['custom_event'].apply(this, [this, defaultAttrs]);
    });
    // 评论大图
     $(document).on('click', '.jdgm-rev-widg__body .jdgm-rev__pics', function () {
     
      const defaultAttrs = {
        content_type: 'product_comment',
        section_id: 'product_comment',
        section_name: 'product_comment',
        series_name: `product_comment_detail_picture`,
      };
        console.log('画廊内索引:', defaultAttrs);
      GA4Events['custom_event'].apply(this, [this, defaultAttrs]);
    });
    
  });
})(jQuery);
